import React, { useContext } from 'react';
import { useGetGlobalAttributes, useGetXstyledProps, useOwnerProps } from '@elliemae/ds-props-helpers';
import { TabsPanels } from '../tabsPanel/TabsPanels.js';
import { TabBar } from '../tabBar/TabBar.js';
import { StyledTabBarContainer, StyledTabsContainer } from './styles.js';
import { DSTabsContext } from '../../DSTabsCTX.js';

export const TabsContent = (): JSX.Element => {
  const {
    props,
    props: { containerProps, innerRef, tabsListAriaLabel, tabBarExtraContent, TabBarExtraContent },
  } = useContext(DSTabsContext);

  const globalProps = useGetGlobalAttributes(props);
  const xstyledProps = useGetXstyledProps(props);
  const { getOwnerProps, getOwnerPropsArguments } = useOwnerProps(props);

  return (
    <StyledTabsContainer
      {...globalProps}
      {...xstyledProps}
      {...containerProps}
      innerRef={innerRef}
      getOwnerProps={getOwnerProps}
      getOwnerPropsArguments={getOwnerPropsArguments}
    >
      <StyledTabBarContainer aria-label={tabsListAriaLabel}>
        <TabBar />
        {TabBarExtraContent ? <TabBarExtraContent /> : null}
        {tabBarExtraContent || null}
      </StyledTabBarContainer>
      <TabsPanels />
    </StyledTabsContainer>
  );
};
